import { mapGetters, mapActions } from 'vuex'
import { charset7bit } from '@/config/charsets.js'
import { getSubvariablesTitle, getDefaultVariablesTitle, getBestOfferVariablesTitle, getValiditySubvariablesTitle } from '@/modules/maria/helpers/variables.js'

export const charCount = {
  data: () => ({
    offerTypesToCountName: [
      'offer_sales',
      'percentage_offer_sales',
      'cashback_absolute_offer_sales',
      'cashback_percentage_offer_sales',
      'takepay_offer_sales',
      'points_offer_sales',
    ],
  }),
  computed: {
    ...mapGetters(['getVariableCharCount', 'channelsCharCount', 'campaignVariablesConfiguration', 'getChannelCharCount']),
  },
  methods: {
    ...mapActions(['setAllChannelsCharCount', 'setVariableCharCount']),

    countNameVariablesChar() {
      try {
        let maxNameLength = 0

        if (this.campaign?.offer_sales?.length > 0) {
          this.campaign.offer_sales.forEach((offer) => {
            if (offer?.name) {
              maxNameLength = Math.max(maxNameLength, offer.name.length)
            }
          })
        }

        if (this.campaign?.offer_schedules?.length > 0) {
          this.campaign.offer_schedules.forEach((schedule) => {
            this.offerTypesToCountName.forEach((offerType) => {
              const offers = schedule[offerType] || []
              offers.forEach((offer) => {
                if (offer?.group_name) {
                  maxNameLength = Math.max(maxNameLength, offer.group_name.length)
                } else if (offer?.name) {
                  maxNameLength = Math.max(maxNameLength, offer.name.length)
                }
              })
            })
          })
        }

        if (maxNameLength !== this.getVariableCharCount('{nome produto}')) {
          this.setVariableCharCount({ variable: '{nome produto}', charCount: maxNameLength })
        }
      } catch (error) {
        console.error('Error counting name variables char', error)
      }
    },

    countComboNameChar() {
      try {
        let maxNameLength = 0

        if (this.campaign?.offer_schedules?.length > 0) {
          this.campaign.offer_schedules.forEach((schedule) => {
            const comboName = schedule.combo_offer_sales?.name
            if (comboName) {
              maxNameLength = Math.max(maxNameLength, comboName.length)
            }
          })
        }

        if (maxNameLength !== this.getVariableCharCount('{nome do combo}')) {
          this.setVariableCharCount({ variable: '{nome do combo}', charCount: maxNameLength })
        }
      } catch (error) {
        console.error('Error counting combo name char', error)
      }
    },

    countBestOfferTextChar() {
      try {
        let localChannelsCharCount = JSON.parse(JSON.stringify(this.channelsCharCount))

        Object.entries(this.campaignVariablesConfiguration).forEach(([channel, channelData]) => {
          Object.entries(channelData).forEach(([field, fieldData]) => {
            Object.entries(fieldData).forEach(([offerType, offerData]) => {
              localChannelsCharCount[channel][field][offerType].repeatableCharCount = this.countTextWithSubvariables(offerData?.repeatable_text)
              localChannelsCharCount[channel][field][offerType].validityCharCount = this.countTextWithSubvariables(offerData?.validity_text)
            })
          })
        })

        const isEqual = JSON.stringify(localChannelsCharCount) === JSON.stringify(this.channelsCharCount)
        if (!isEqual) {
          this.setAllChannelsCharCount(localChannelsCharCount)
        }
      } catch (error) {
        console.error('Error counting best offer text char', error)
      }
    },

    countBestOfferVariablesCharCount(channel, field, offerType, amount) {
      const { repeatableCharCount, validityCharCount } = this.getChannelCharCount(channel, field, offerType)
      return repeatableCharCount * amount + validityCharCount
    },

    countTextWithSubvariables(text) {
      if (!text) return 0
      const parts = text.split(/(\{[^}]+\})/g)
      return parts.reduce((total, part) => {
        if (getSubvariablesTitle().includes(part)) {
          return total + (this.getVariableCharCount(part) || 0)
        }
        return total + part.length
      }, 0)
    },

    countTextWithVariables(text, channel, field, offerType) {
      if (!text) return 0
      const parts = text.split(/(\[[^\]]+\])/g)
      return parts.reduce((total, part) => {
        if (getDefaultVariablesTitle().includes(part)) {
          return total + (this.getVariableCharCount(part) || 0)
        } else if (getBestOfferVariablesTitle().includes(part)) {
          const amount = part.match(/\[(\d+) melhor oferta\]/)[1]
          return total + this.countBestOfferVariablesCharCount(channel, field, offerType, amount)
        }
        return total + part.length
      }, 0)
    },

    hasSpecialCharactersInText(text) {
      const normalCharSet = new Set(charset7bit)
      const parts = text.split(/(\{[^}]+\}|\[[^\]]+\])/g)
      const validVariables = [...getSubvariablesTitle(), ...getDefaultVariablesTitle(), ...getBestOfferVariablesTitle(), ...getValiditySubvariablesTitle()]

      return parts.reduce((hasSpecial, part) => {
        if (hasSpecial) return true

        if (part.startsWith('{') || part.startsWith('[')) {
          if (validVariables.includes(part)) {
            return hasSpecial
          }

          return part.split('').some((char) => !normalCharSet.has(char))
        }

        return hasSpecial || part.split('').some((char) => !normalCharSet.has(char))
      }, false)
    },
  },
}
